module.exports = __webpack_public_path__ + "static/media/MEINCA_MENU-normal.5271fb7a.png";